import styled from "styled-components";
import { TextField as TextFieldMUI } from "@mui/material";
import materialUI from "../../../../../../material-UI";

export const Container = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export const InputLable = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  margin-bottom: 4px;
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)``;

export const RoletaButton = styled.button`
  box-sizing: border-box;

  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;

  border-radius: 20px;
  background: #eaefff;
  border: none;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    margin-left: 8px;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #2d5bff;

    white-space: nowrap;
  }
`;

export const GerarRelatorioButton = styled.button`
  box-sizing: border-box;

  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;

  border-radius: 20px;
  background: ${(props: any) => (props.disabled ? "#e0e0e0" : "#ffffff")};
  border: none;
  cursor: ${(props: any) => (props.disabled ? "not-allowed" : "pointer")};

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    margin-left: 8px;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #4caf50;

    white-space: nowrap;
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 42px;
  background: #2d5bff;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 32px 0 32px;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ColumnAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
  padding: 0 8px 0 8px;
`;

export const Space: any = styled.div`
  min-height: ${(props: any) => props.space}px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  max-width: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: #2d5bff !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
  &:hover {
    fieldset {
      border-color: #2d5bff !important; // Adiciona a cor azul no hover
    }
  }

  &:focus {
    fieldset {
      border-color: #2d5bff !important; // Adiciona a cor azul no foco
    }
  }
`;

export const CustomTextField = styled(TextFieldMUI)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: "40px",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWith: "2px",
    borderColor: "#2D5BFF",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderWith: "2px",
    borderColor: "#2D5BFF",
  },
  "&.Mui-focused fieldset": {
    borderWith: "2px",
    borderColor: "#2D5BFF !important",
  },
}));
